import React, { Component, Fragment } from "react";
import Header from "./header";
import Functions from "../../../src/functions";

class Error extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
		});
		Functions.addScript("/resources/js/jquery-1.8.3.min.js");
		Functions.addScript("/resources/js/jquery.backstretch.min.js");
		Functions.addScript("/resources/js/jquery.easing.1.3.js");
		Functions.addScript("/resources/js/jquery.jscrollpane.min.js");
		Functions.addScript("/resources/js/jquery.mousewheel.js");
		Functions.addScript("/resources/js/jquery.nicescroll.min.js");
		Functions.addScript("/resources/js/dlp.libraries.1.0.js");
		Functions.addScript("/resources/js/deeplink.js");
		Functions.addScript("/resources/js/remote-logger.js");
		Functions.addScript("/resources/js/mwheelIntent.js");
		Functions.addScript("/resources/js/main.js");
		Functions.addScript("/resources/js/dlp.main.1.0.js");
		Functions.addCosmoteTelekomCSS();
	}

	render() {
		if (this.state.loaded) {
			return (
				<div>
					{this.props.wifi ? (
						<>
							<Header />
							<div
								className="thank-hold errorPageDisplay"
								style={{ display: "none" }}>
								<div
									className="thank"
									style={{ display: "block" }}>
									<h2 className="errorheader customClassErrorHeader">
										Η υπηρεσία My Internet είναι διαθέσιμη μόνο μέσω του δικτύου
										TELEKOM. Παρακαλούμε απενεργοποίησε το Wi-Fi στο κινητό σου
										και ενεργοποίησε τα δεδομένα στο 3G ή 4G δίκτυο της TELEKOM
										από τις ρυθμίσεις του κινητού σου. <br />
										<br />Η χρήση της σελίδας είναι δωρεάν και δεν
										καταναλώνονται τα διαθέσιμα ΜΒ
									</h2>
								</div>
							</div>
						</>
					) : (
						<>
							<Header />
							<div
								className="thank-hold errorPageDisplay"
								style={{ display: "none" }}>
								<div
									className="thank"
									style={{ display: "block" }}>
									<h2 className="errorheader">
										Σας ενημερώνουμε ότι η υπηρεσία <br /> αυτή τη στιγμή δεν
										είναι διαθέσιμη.
									</h2>{" "}
									<h2 className="errorheader2">
										Για περισσότερες πληροφορίες καλέστε <br />
										την Εξυπηρέτηση Πελατών, <br /> 13888 Ιδιώτες,13818
										Επαγγελματίες{" "}
									</h2>{" "}
									<a
										href="/"
										className="cancel">
										Επιστροφή &gt;
									</a>
								</div>
							</div>
						</>
					)}
				</div>
			);
		} else {
			return "";
		}
	}
}

export default Error;
